export type Interval = {
  start: Date | null;
  end: Date | null;
};

export default function isWithinInterval(date: Date, interval: Interval) {
  const time = +new Date(date);
  const startTime = interval.start ? +new Date(interval.start) : -Infinity;
  const endTime = interval.end ? +new Date(interval.end) : Infinity;

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}
